<script lang="ts">
  type Props = {
    hidden: boolean
    parsedGcode: ParsedGcodeLine[]
    progress: number
  }

  const { hidden, parsedGcode, progress }: Props = $props()
</script>

{#if !hidden}
  <div class="gcode-preview">
    {#each [-4, -3, -2, -1, 0, 1, 2, 3, 4] as index (index)}
      {@const gcodeLine = parsedGcode[progress + index]}
      {#if gcodeLine}
        <div>
          {gcodeLine.originalLine}
        </div>
      {/if}
    {/each}
  </div>
{/if}

<style lang="scss">
  .gcode-preview {
    position: absolute;
    top: 4rem;
    left: 1rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: stretch;
    z-index: 10;
    gap: 0.25rem;

    > div {
      font-size: 0.75rem;
      font-family: monospace;
    }

    :nth-child(5) {
      font-size: 1rem;
    }

    :nth-child(1),
    :nth-child(9) {
      opacity: 20%;
    }

    :nth-child(2),
    :nth-child(8) {
      opacity: 40%;
    }

    :nth-child(3),
    :nth-child(7) {
      opacity: 60%;
    }

    :nth-child(4),
    :nth-child(6) {
      opacity: 80%;
    }
  }
</style>
